export default () => {

    const {getRobotsMeta, getLinks} = useSeoMeta()

    return {
        meta: [
            ...getRobotsMeta(),
        ],
        link: () => [...getLinks()]
    }
}